import EmptyView from '@/views/empty-view.vue';
import { useUserStore } from '@/stores/user.store';

export default {
  name: 'logout',
  path: '/logout',
  component: EmptyView,
  meta: {
    title: 'Logout',
    authenticated: false,
    activeUser: false,
    enabled: true,
  },
  beforeEnter() {
    const userStore = useUserStore();
    userStore.logout();

    window.location.href = '/';
  },
};
